import { displayLatLonInCompassFormat } from '@deckee/utilities';
import React from 'react';
import { haulOut } from '../../../components/shared/vector-images';
import Text from '../../../components/shared/_deprecated/elements/Text/Text';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Haul-out facility',
  synonyms: 'yard boat yard boatyard',
  group: 'standardMarker',
  typeUrl: 'haul-out-facility',
  icon: {
    baseShape: haulOut,
    iconColor: '#fff',
    markerColor: '#56AC5C',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'marine-facilities',
    order: 1000,
  },
  standardMarkerOptions: {
    markerType: 'hauloutFacilityMarker',
    allowCreation: true,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Haul-out facility',
      itemTitleFunction: (item) => (item && item.title) || 'Haul-out facility',
    },
    creationOptions: {
      menuText: 'Haul-out facility',
      newTitle: 'Haul-out facility',
      titlePlaceholder: 'Name of haul-out facility',
      markerTypeDescription: [
        <Text key="description-text-1" size="-1" paragraph>
          This marker indicates a haul-out facility location. Specify additional
          information like equipment type (sling, slip etc.), depth, max vessel
          length and max tonnage.
        </Text>,
        <Text key="description-text-2" size="-1" paragraph>
          Information provided should be factual. Once you submit this marker,
          you can add your personal experiences or questions as a comment
          underneath.
        </Text>,
      ],
      checkBoxItems: [],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: layer.standardMarkerOptions.markerType,
    id: marker.id,
    displayChat: true,
    displayUpVotes: true,
    title: 'Haul-out facility location',
    description: displayLatLonInCompassFormat(marker.latLon),
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

export default layer;
